module.exports = __webpack_public_path__ + "img/488.532fcc70.png";